import { render, staticRenderFns } from "./RsIndex.vue?vue&type=template&id=29762fd6&scoped=true&"
import script from "./RsIndex.vue?vue&type=script&lang=js&"
export * from "./RsIndex.vue?vue&type=script&lang=js&"
import style0 from "./RsIndex.vue?vue&type=style&index=0&id=29762fd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29762fd6",
  null
  
)

export default component.exports